const SUCCESS_STATUSES = [
  'active',
  'approved',
  'closed',
  'completed',
  'evaluated',
  'success',
  'verified'
];

const WARNING_STATUSES = [
  'assignment found',
  'checked in',
  'in progress',
  'pending',
  'scheduled',
  'under maintenance',
  'under review',
  'waiting'
];

const DANGER_STATUSES = [
  'blocked',
  'cancelled',
  'canceled',
  'failed',
  'inactive',
  'rejected',
  'retired'
];

const INFO_STATUSES = [
  'draft',
  'new',
  'open',
  'processing'
];

export function isEmptyDisplayValue(value: unknown) {
  return value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
}

export function displayValue(value: unknown) {
  if (isEmptyDisplayValue(value)) return '--';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
}

export function statusBadgeClass(value: unknown) {
  const text = String(value || '').trim().toLowerCase();
  if (!text) return 'status-neutral';
  if (SUCCESS_STATUSES.some((status) => text.includes(status))) return 'status-success';
  if (DANGER_STATUSES.some((status) => text.includes(status))) return 'status-danger';
  if (WARNING_STATUSES.some((status) => text.includes(status))) return 'status-warning';
  if (INFO_STATUSES.some((status) => text.includes(status))) return 'status-info';
  return 'status-neutral';
}

export function statusBadgeIcon(value: unknown) {
  const badgeClass = statusBadgeClass(value);
  if (badgeClass === 'status-success') return 'check_circle';
  if (badgeClass === 'status-danger') return 'cancel';
  if (badgeClass === 'status-warning') return 'warning_amber';
  if (badgeClass === 'status-info') return 'info';
  return 'radio_button_checked';
}
